import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "gfu-media__body _pt-1 _ov-h" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = { class: "gfu-bt gfu-bt--caption _tc--light" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("a", {
    href: $options.urlWithRef,
    class: "gfu-media gfu-link gfu-link--nofx gfu-link--block"
  }, [
    _createVNode(_component_base_image, {
      src: $props.thumbImageUrl,
      alt: $props.title,
      width: "48",
      height: "48",
      class: "_mr-2",
      loading: "lazy"
    }, null, 8 /* PROPS */, ["src", "alt"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        class: "gfu-hd gfu-hd--h4 _ttu",
        "data-qa": `search-form-results-list-item:${$props.title}`
      }, _toDisplayString($props.title), 9 /* TEXT, PROPS */, _hoisted_3),
      _createElementVNode("span", _hoisted_4, [
        _renderSlot(_ctx.$slots, "subtitle", {}, () => [
          _createTextVNode(_toDisplayString($props.subtitle), 1 /* TEXT */)
        ])
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}